import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";
import PortalProjectListView from "../views/PortalProjectListView.vue";
import PortalProjectView from "../views/PortalProjectView.vue";
import AccountInfoView from "@/views/AccountInfoView.vue";
import ChangePasswordView from "@/views/ChangePasswordView.vue";
import ResetPasswordView from "@/views/ResetPasswordView.vue";
import AdminDashboardView from "@/views/AdminDashboardView.vue";
import AddProjectView from "@/views/AddProjectView.vue";
import EntitiesListView from "@/views/EntitiesListView.vue";
import AccessDeniedView from "@/views/AccessDeniedView.vue";
import ListManagerView from "@/views/ListManagerView.vue";
import UserListView from "@/views/UserListView.vue";
import ApplicationSettings from "@/views/ApplicationSettings.vue";
import CustomFieldManager from "@/views/CustomFieldManager.vue";
import AdminProjectListView from "@/views/AdminProjectListView.vue";
import ProjectDashboard from "@/views/ProjectDashboard.vue";
import LedgerList from "@/views/LedgerList.vue";
import LedgerDashboard from "@/views/LedgerDashboard.vue";
import PortalLoginView from "@/views/PortalLoginView.vue";
import ReportCustomizationView from "@/views/ReportCustomizationView.vue";
import SubdivisionList from "@/views/SubdivisionList.vue";
import SubdivisionDashboard from "@/views/SubdivisionDashboard.vue";
import { Role } from "./Role";
import SSOLoginView from "@/views/SSOLoginView.vue";
import LicenseKeyUpload from "@/views/LicenseKeyUpload.vue";

export {};

declare module "vue-router" {
  interface RouteMeta {
    requiredRole: Role;
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "admin-login",
      component: LoginView,
    },
    {
      path: "/portal",
      name: "portal-login",
      component: PortalLoginView,
    },
    {
      path: "/portal/projects",
      name: "portal-project-list",
      component: PortalProjectListView,
      meta: {
        requiredRole: Role.USER,
      },
    },
    {
      path: "/portal/projects/:id",
      name: "portal-project",
      component: PortalProjectView,
      meta: {
        requiredRole: Role.USER,
      },
    },
    {
      path: "/portal/myaccount",
      name: "portal-my-account",
      component: AccountInfoView,
      meta: {
        requiredRole: Role.ANY,
      },
    },
    {
      path: "/portal/changepass",
      name: "portal-change-pass",
      component: ChangePasswordView,
      meta: {
        requiredRole: Role.ANY,
      },
    },
    {
      path: "/portal/resetpass",
      name: "portal-reset-password",
      component: ResetPasswordView,
    },
    {
      path: "/myaccount",
      name: "my-account",
      component: AccountInfoView,
      meta: {
        requiredRole: Role.ANY,
      },
    },
    {
      path: "/changepass",
      name: "change-pass",
      component: ChangePasswordView,
      meta: {
        requiredRole: Role.ANY,
      },
    },
    {
      path: "/resetpass",
      name: "reset-password",
      component: ResetPasswordView,
    },
    {
      path: "/admin-dashboard",
      name: "admin-dashboard",
      component: AdminDashboardView,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/add-project",
      name: "add-project",
      component: AddProjectView,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/entities",
      name: "list-entities",
      component: EntitiesListView,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/accessdenied",
      name: "access-denied",
      component: AccessDeniedView,
    },
    {
      path: "/list-manager",
      name: "list-manager",
      component: ListManagerView,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/users",
      name: "list-users",
      component: UserListView,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/appsettings",
      name: "app-settings",
      component: ApplicationSettings,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/customfields",
      name: "custom-fields",
      component: CustomFieldManager,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/project-list",
      name: "project-list",
      component: AdminProjectListView,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/project-dashboard:id",
      name: "project-dashboard",
      component: ProjectDashboard,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/ledgers",
      name: "ledgers",
      component: LedgerList,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/ledgers/:id",
      name: "ledger-dashboard",
      component: LedgerDashboard,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/reportcustom/:reportId?",
      name: "report-customization",
      component: ReportCustomizationView,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/subdivisions",
      name: "subdivision-list",
      component: SubdivisionList,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/subdivisions/:id",
      name: "subdivision-dashboard",
      component: SubdivisionDashboard,
      meta: {
        requiredRole: Role.ADMIN,
      },
    },
    {
      path: "/login",
      name: "sso-login",
      component: SSOLoginView,
    },
    {
      path: "/license-key-upload",
      name: "license-key-upload",
      component: LicenseKeyUpload,
    },
  ],
});

export default router;
